// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2698":"33ca6280","4745":"33ca6280","5288":"4bf62bde","5606":"e17ee9d4","9560":"7eaa8808"}[chunkId] + ".chunk.css";
};